import { StarbaseEntity } from 'starbase-launcher';
import { IColumnModel, ColumnModel } from 'table-editor';

export class BranchOfService extends StarbaseEntity {
    public branchName: string;

    constructor() {
        super();
    }

    public static BranchOfServiceColumnData(editable: boolean = false): IColumnModel[] {
        return [
            new ColumnModel('UID', 'uid', 'UID', false, 'number', false, true, 10, false),
            new ColumnModel('Branch', 'branchName', 'branchName', editable, 'string', true, true, 100, false),
            new ColumnModel('Created By', 'createdByUser', 'CreatedByUser', false, 'string', false, true, 100, false),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'CreatedDateTime', false, 'date', false, true, 50, false)
        ];
    }

  deserialize(input) {
    return Object.assign(new BranchOfService(), input);
        // this.branchName = input.branchName;
        // this.uid = input.uid;
        // this.createdByUser = input.createdByUser;
        // this.createdDateTime = input.createdDateTime;
        // return this;
    }
}
